import { CURRENT_BRAND } from "@/brand/config";
import { useTheme } from "@/components/useTheme";

export function BrandMark() {
  const { isDark } = useTheme();
  const src = isDark
    ? CURRENT_BRAND.logos.header.squareDark
    : CURRENT_BRAND.logos.header.squareLight;
  return (
    <span className="brand__mark" aria-hidden="true">
      <img
        src={src}
        alt=""
        onError={(e) => ((e.target as HTMLImageElement).style.display = "none")}
      />
    </span>
  );
}
